import FaxManagementHeader from './FaxManagementHeader.view';

export default FaxManagementHeader;
